import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { View, StyleSheet, Text, ActivityIndicator } from 'react-native';
import { TextInput as Input } from 'react-native-paper';
import { useTheme } from 'react-native-paper';
import Icon from 'react-native-vector-icons/MaterialIcons';

const TextInput = ({
  errorText,
  isValidating = false,
  isValid = false,
  showValidationIcons = false,
  ...props
}) => {
  const theme = useTheme();

  // Determine right icon based on validation state
  const getRightIcon = () => {
    if (!showValidationIcons) return null;

    if (isValidating) {
      return () => (
        <ActivityIndicator size="small" color={theme.colors.primary} />
      );
    }

    if (props.value && props.value.trim().length > 0) {
      if (errorText) {
        return () => <Icon name="error" size={20} color={theme.colors.error} />;
      } else if (isValid) {
        return () => (
          <Icon name="check-circle" size={20} color={theme.colors.primary} />
        );
      }
    }

    return null;
  };

  return (
    <View style={styles.container}>
      <Input
        mode="outlined"
        textColor={theme.colors.inputTxtColor}
        underlineColor="transparent"
        style={[styles.input, { backgroundColor: theme.colors.onBackground }]}
        outlineColor={theme.colors.OnBackgroundDarkBorder}
        theme={{
          colors: {
            onSurfaceVariant: theme.colors.placeHolderText,
            primary: theme.colors.primary,
            onSurface: theme.colors.inputTxtColor,
          },
          fonts: { bodyLarge: { fontSize: 12 } },
        }}
        placeholderTextColor={theme.colors.placeHolderText}
        right={getRightIcon() ? <Input.Icon icon={getRightIcon()} /> : null}
        {...props}
      />

      {errorText ? (
        <Text style={[styles.error, { color: theme.colors.errorColor }]}>
          {errorText}
        </Text>
      ) : null}
    </View>
  );
};

TextInput.propTypes = {
  errorText: PropTypes.string,
  isValidating: PropTypes.bool,
  isValid: PropTypes.bool,
  showValidationIcons: PropTypes.bool,
};

const styles = StyleSheet.create({
  container: {
    width: '100%',
    marginVertical: 5,
  },
  input: {
    fontSize: 12,
    borderRadius: 8,
    minHeight: 48,
    //border: '1px solid #1E243D'
  },
  error: {
    fontSize: 11,
    paddingHorizontal: 4,
    paddingTop: 4,
  },
});

export default memo(TextInput);
